// extracted by mini-css-extract-plugin
var _1 = "IntegrationsPanelFacts-moduleIntegrationsPanelFacts__Q4AI9";
export { _1 as "IntegrationsPanelFacts" }
